import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useGetCostsInvoicingHeaders, usePostCostInvoicingEmailCosts } from 'api';

import ToastMessage from 'components/toastMessage';
import { Box, Button } from 'components/ui';
import { DateRange } from 'components/containers';
import { SendDocumentsModal } from '../SendDocumentsModal/SendDocumentsModal';
import { resources } from 'oems/resources';

import * as Styled from './Sidebar.styles';
import { Subscribe, Unsubscribe, Event } from 'utility/Events/Events';

dayjs.extend(utc);

export const Sidebar = () => {
  const [currentDates, setCurrentDates] = useState({});
  const [isSendDocumentsModal, setIsSendDocumentsModal] = useState(false);
  const [toastData, setToastData] = useState(null);

  const { mutate: sendEmail, isLoading: isSendingEmail } = usePostCostInvoicingEmailCosts({
    onSuccess: () => {
      setIsSendDocumentsModal(false);
      setToastData({ severity: 'success', message: 'Wiadomość wysłana' });
    },
    onError: () => {
      setToastData({ severity: 'error', message: 'Nie udało się wysłać wiadomości' });
    },
  });

  const { data: costHeadersData, refetch:refetchCostHeadersData, isLoading: isCostHeadersDataLoading } = useGetCostsInvoicingHeaders(
    {
      from: dayjs.utc(currentDates.fromDate).toISOString(),
      to: dayjs.utc(currentDates.toDate).endOf('day').toISOString(),
      limit: 999,
      offset: 0,
    },
    {
      enabled: !!currentDates.fromDate && !!currentDates.toDate,
    },
  );

  useEffect(() => {
    Subscribe(Event.onCostListNeedsRefresh, refetchCostHeadersData);

    return () => {
      Unsubscribe(Event.onCostListNeedsRefresh, refetchCostHeadersData);
    };
  }, []);

  return (
    <Box>
      <Styled.Title>Wyślij dokumenty</Styled.Title>

      <Styled.DateRangeWrapper>
        <DateRange onChange={setCurrentDates} toDate={currentDates.toDate} fromDate={currentDates.fromDate} />
      </Styled.DateRangeWrapper>

      <Styled.Documents>Dokumenty do wysyłki: {costHeadersData && costHeadersData.length}</Styled.Documents>

      <Styled.Divider />

      <Styled.ButtonWrapper>
        <Button
          variant="outlined"
          onClick={() => setIsSendDocumentsModal(true)}
          disabled={isCostHeadersDataLoading || (costHeadersData || []).length === 0}
        >
          <resources.EmailEditIcon /> Dołącz wiadomość i wyślij
        </Button>
      </Styled.ButtonWrapper>

      {isSendDocumentsModal && (
        <SendDocumentsModal
          onClose={() => setIsSendDocumentsModal(false)}
          documentsCount={(costHeadersData || []).length}
          onConfirm={(params) =>
            sendEmail({
              ...params,
              from: dayjs.utc(currentDates.fromDate).toISOString(),
              to: dayjs.utc(currentDates.toDate).endOf('day').toISOString(),
            })
          }
          isSending={isSendingEmail}
        />
      )}

      {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}
    </Box>
  );
};
